export default __webpack_public_path__ + "static/media/clip.0ffbba75.svg";